module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/8-d4e76dfd9983f7763ccee6670968e16d.jpg";